export default "__VITE_PUBLIC_ASSET__d2af370a__"